module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.organizedTournaments.length > 0) ? _c('section', [_c('h2', [_vm._v("Als Veranstalter")]), _vm._v(" "), _vm._l((_vm.organizedTournaments), function(t) {
    return _c('router-link', {
      key: t.id,
      staticClass: "item",
      attrs: {
        "to": ("tournament/" + (t.id))
      }
    }, [_c('img', {
      staticClass: "tournament",
      attrs: {
        "src": "images/tournament-dark.png"
      }
    }), _vm._v(" "), _c('h3', [_vm._v("\n                " + _vm._s(t.name) + "\n            ")]), _vm._v(" "), _c('small', [_vm._v("\n                " + _vm._s(_vm._f("tournament_status")(t.status)) + "\n            ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.invitations.length > 0) ? _c('section', [_c('h2', [_vm._v("Als Teilnehmer")]), _vm._v(" "), _vm._l((_vm.invitations), function(inv) {
    return _c('router-link', {
      key: inv.id,
      staticClass: "item",
      attrs: {
        "to": ("tournament/" + (inv.tournament_id))
      }
    }, [_c('img', {
      staticClass: "tournament",
      attrs: {
        "src": "images/tournament-dark.png"
      }
    }), _vm._v(" "), _c('h3', [_vm._v("\n                " + _vm._s(inv.tournament.name) + "\n            ")]), _vm._v(" "), _c('small', [_vm._v("\n                " + _vm._s(_vm._f("tournament_status")(inv.tournament.status)) + "\n            ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.activities.length > 0) ? _c('section', {
    staticClass: "activities"
  }, [_c('h2', [_vm._v("Aktivität")]), _vm._v(" "), _c('timeline', {
    attrs: {
      "activities": _vm.activities
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.organizedTournaments.length == 0 &&
    _vm.invitations.length == 0) ? _c('section', [_c('h2', [_vm._v("Turniere")]), _vm._v(" "), _vm._m(0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-results"
  }, [_vm._v("\n            Hier ist noch nichts los :("), _c('br'), _vm._v("\n            Organisiere ein Turnier, um das zu ändern!\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ad39adc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/tournaments.vue
// module id = 226
// module chunks = 0